import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import authReducer from './slices/auth'
import usersReducer from './slices/users'
import adminsReducer from './slices/admins'
import adminAuthReducer from './slices/adminAuth'

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'redux',
  storage,
  keyPrefix: '',
  whitelist: ['auth', 'users', 'admins', 'adminAuth'],
};

const rootReducer = combineReducers({
  auth: authReducer,
  users: usersReducer,
  admins: adminsReducer,
  adminAuth: adminAuthReducer,
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  product: productReducer,
});

export default rootReducer;
